import {Text} from '@rdcomponents/text/text';

import {Locale} from '../../../../../../../provider/locale/localization';

import * as styles from './lps-status.scss';

type LpsStatusPropsType = {
    averageLps?: number;
    isError?: boolean;
};

export function LpsStatus({averageLps, isError}: LpsStatusPropsType): JSX.Element | null {
    if (isError) {
        return <>-</>;
    }

    // eslint-disable-next-line no-undefined
    if (averageLps === null || averageLps === undefined) {
        return null;
    }

    if (averageLps <= 50) {
        return (
            <>
                {averageLps}
                <Text bolder className={styles.LpsStatus_badRating}>
                    <Locale stringKey="MY_COMPANIES__LPS_RATING__LOW" />
                </Text>
            </>
        );
    }

    if (averageLps <= 80) {
        return (
            <>
                {averageLps}
                <Text bolder className={styles.LpsStatus_mediumRating}>
                    <Locale stringKey="MY_COMPANIES__LPS_RATING__MEDIUM" />
                </Text>
            </>
        );
    }

    return (
        <>
            {averageLps}
            <Text bolder className={styles.LpsStatus_goodRating}>
                <Locale stringKey="MY_COMPANIES__LPS_RATING__HIGH" />
            </Text>
        </>
    );
}
